import type { CreateAllocationsRequest, CreateAllocationsResponseApi } from '@/types/api/allocations';

/**
 * Demo-mode fabricated response for creating allocations.
 * Used as the demoFn for useCreateAllocations.
 */
export async function createAllocationsDemoResponse(
  request: CreateAllocationsRequest,
): Promise<CreateAllocationsResponseApi> {
  return {
    receiptId: request.receiptId,
    allocations: request.allocations.map((a, index) => ({
      id: Date.now() + index,
      receiptId: request.receiptId,
      transactionId: a.transactionId,
      allocatedAmount: a.allocatedAmount,
      allocationDate: new Date().toISOString(),
      allocationMethod: a.allocationMethod,
      notes: a.notes,
      createdBy: 'demo-user',
      createdAt: new Date().toISOString(),
    })),
    receiptSummary: {
      receivedAmount: 0,
      allocatedAmount: request.allocations.reduce((sum, a) => sum + a.allocatedAmount, 0),
      unappliedAmount: 0,
      allocationStatus: 'fully_allocated',
    },
  };
}
